import { render, staticRenderFns } from "./GlobalSettingsDropdownMenu.vue?vue&type=template&id=c12f2e76&"
import script from "./GlobalSettingsDropdownMenu.vue?vue&type=script&lang=ts&"
export * from "./GlobalSettingsDropdownMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports